import React from "react";

// import styled components
import {
  FooterContainer,
  FooterLeft,
  FooterRight,
  FooterWrapper,
} from "./styled";

// import assets
import ehl from "../../assets/othl/ehl-blue.png";

const Footer = () => (
  <FooterWrapper>
    <FooterContainer>
      <FooterLeft>
        <p>© 2016 - {new Date().getFullYear()} OneTrust Home Loans</p>
        <p>
          <a
            href="https://onetrusthomeloans.com/licensing-information/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Licensing
          </a>
          &nbsp;|&nbsp;
          <a
            href="https://onetrusthomeloans.com/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy
          </a>
          <a
            href="https://onetrusthomeloans.com/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy
          </a>
        </p>
      </FooterLeft>
      <FooterRight>
        <img src={ehl} alt="Equal Housing Lender" />
        <p>
          CalCon Mutual Mortgage LLC, dba OneTrust Home Loans is an Equal
          Housing Lender NMLS #46375 (
          <a
            href="http://www.nmlsconsumeraccess.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.nmlsconsumeraccess.org
          </a>
          ); 3838 Camino del Rio N Suite 305, San Diego, CA 92108. Corporate
          phone (888) 488-3807.
        </p>
      </FooterRight>
    </FooterContainer>
  </FooterWrapper>
);

export default Footer;
